export default __webpack_public_path__ + "static/media/email-icon.d26d2a63.svg";